import { useRef, useState } from 'react';
import { Swiper, SwiperSlide, SwiperClass } from 'swiper/react';

import { Autoplay } from 'swiper';
import 'swiper/css';

import { LazyVideo } from '@commonPackage/components';
import { VideoCardDataType } from '../../pages/corporateSpace/helper';

import cx from './index.module.less';

export const VideoCard = ({ dataSource }: { dataSource: VideoCardDataType[] }) => {
  const videoRefs = useRef<(HTMLVideoElement | null)[]>([]);
  const progressRef = useRef<HTMLDivElement | null>(null);
  const [curNum, setCurNum] = useState(0);
  const [swiper, setSwiper] = useState<SwiperClass>();

  const onSlideChange = (sw: SwiperClass) => {
    setCurNum(sw?.activeIndex || 0);
    const preVideo = videoRefs.current[sw?.previousIndex];
    if (preVideo) {
      preVideo.muted = true;
    }
    let video = videoRefs.current[sw?.activeIndex];
    if (video) {
      video.currentTime = 0;
    }
  };

  return (
    <div className={cx('video-card-wrapper')}>
      <Swiper
        onSwiper={sw => setSwiper(sw)}
        spaceBetween={30}
        centeredSlides={true}
        onSlideChange={onSlideChange}
        autoplay={{
          disableOnInteraction: false,
        }}
        modules={[Autoplay]}
        className={cx('swiper')}>
        {dataSource.map(data => (
          <SwiperSlide key={data.serialNum} data-swiper-autoplay={data.swiperDelay}>
            <div className={cx('video-container')}>
              <LazyVideo
                key={data.serialNum}
                className={cx('video')}
                src={data.video ?? ''}
                muted
                controls
                controlsList="nodownload nofullscreen noremoteplayback noplaybackrate"
                disablePictureInPicture
                loop
                autoPlay
                preload="auto"
                videoRef={element => {
                  videoRefs.current[data.serialNum] = element;
                }}
                onLoadedMetadata={() => {
                  const progressStyle = progressRef.current?.style;
                  if (progressStyle) {
                    progressStyle.animationDelay = `-${data.swiperDelay / 1000}s`;
                    progressStyle.animationPlayState = 'running';
                  }
                }}
              />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      <div className={cx('cards-wrapper')}>
        {dataSource.map(data => (
          <div
            key={data.serialNum}
            className={cx('card', { hover: curNum === data.serialNum })}
            onMouseEnter={() => swiper?.slideTo(data.serialNum)}>
            <div className={cx('progress-bar')}>
              <div className={cx('progress')} style={{ animationDuration: `${data.swiperDelay / 1000}s` }}></div>
            </div>
            <span className={cx('title')}>{data.title}</span>
            <span className={cx('brief')}>{data.brief}</span>
            <span className={cx('sceond-line-brief')}>{data.extraBrief}</span>
            <img src={curNum === data.serialNum ? data.darkImgSrc : data.imgSrc} alt="" />
          </div>
        ))}
      </div>
    </div>
  );
};
